import { CancelationReason } from '@exam-center/graphql';
import { z } from 'zod';

export const CancelExamEventExamineeFormSchema = z.object({
  cancelationReasonCategory: z.nativeEnum(CancelationReason, {
    required_error: 'กรุณาเลือกสาเหตุที่ยกเลิก',
    message: 'กรุณาเลือกสาเหตุที่ยกเลิก',
  }),
  remark: z
    .string()
    .trim()
    .min(1, { message: 'กรุณาระบุสาเหตุ' })
    .max(255, { message: 'ความยาวต้องไม่เกิน 255 ตัวอักษร' }),
});

export type CancelExamEventExamineeFormInput = z.infer<typeof CancelExamEventExamineeFormSchema>;
